import styled from "styled-components";
import React, { Component } from "react";
import { borderRadius, colors } from "./constants";
import Title from "./Title";
import styles from "./styles";

import { throttle } from 'lodash';

const Header = styled.div`
  position: absolute;
  z-index: 999;
  top: 0;
  left: 50%;
  width: 100%;
  margin-bottom: 8px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: ${borderRadius}px;
  border-top-right-radius: ${borderRadius}px;
  background-color: #cfcfcf;
  transition: background-color 0.1s ease;
  &:hover {
    background-color: ${colors.blue.lighter};
  }
`;

export class ColumnHeader extends Component {
  constructor(props) {
    super(props);

    this.topOffset = 0;

    this.state = {
      pos: 0
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = throttle(() => {
    requestAnimationFrame(() => {
      const pos = window.scrollY - this.topOffset;
      this.setState({ pos: pos < 0 ? 0 : pos })
    })
  }, 16)

  addMobileStyles(type) {
    if (window.mobilecheck()) {
      if (type === 'title') {
        return 'mobile-scale-title';
      }
      else {
        return 'mobile-scale-icon';
      }
    }
    else {
      return 'column-title';
    }

    return '';
  }

  setRef = (ref) => {
    if (!ref) return;

    const clientRect = ref.getBoundingClientRect();
    this.topOffset = clientRect.top;
  }

  render() {
    const { snapshot, provided, countItems, title } = this.props;

    const style = {
      transform: `translateY(${this.state.pos}px) translateX(-50%)`
    };
    return (
      <Header innerRef={this.setRef} isDragging={snapshot.isDragging} style={style} >
        <Title
          isDragging={snapshot.isDragging}
          {...provided.dragHandleProps}
        >
          <span className={`${this.addMobileStyles('title')}`}>
            <span>
              <span style={styles.titleText} className="title-dnd">{title}</span>
              <span className="fa-stack" style={styles.circleCounter}>
                <i className="fa fa-circle fa-stack-2x" />
                <span className="fa-stack-1x text-white font-weight-normal">{countItems}</span>
              </span>
            </span>
          </span>
        </Title>
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/ColumnHeader.js